define('bizzabo/models/Global',[], {});
